import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  formId: null,
  roles: {},
  metadata: {}
}

const baseSlice = createSlice({
  name: 'base',
  initialState,
  reducers: {
    load(state, { payload: { roles, formId, metadata } }) {
      state.roles = roles
      state.formId = formId
      state.metadata = metadata
    },
  },
})

export const { load } = baseSlice.actions
export default baseSlice.reducer
